import {Component} from '@angular/core';
import {ViewComponent} from '../view.component';

@Component({
  selector: 'app-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss'],
  standalone: false
})
export class ListViewComponent extends ViewComponent {}
